$( document ).ready(function() {
  
  $('.banner-slider .banner-list').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    adaptiveHeight: true
  });


$('.customer-list').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 1441,
      settings: {
        slidesToShow: 1
      }
    },
     {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
     {
      breakpoint: 641,
      settings: {
        slidesToShow: 1.2
      }
    }
  ]
});

$('.review-list').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 1441,
      settings: {
        slidesToShow: 1
      }
    },
     {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
     {
      breakpoint: 641,
      settings: {
        slidesToShow: 1
      }
    }
  ]
}); 


// $('.product-slider').slick({ 
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   arrows: true,
//   dots: false,
//   infinite: false,
//   responsive: [
//     {
//       breakpoint: 1441,
//       settings: {
//         slidesToShow: 3
//       }
//     },
//     {
//       breakpoint: 992,
//       settings: {
//         slidesToShow: 2
//       }
//     },
//     {
//       breakpoint: 641,
//       settings: {
//         slidesToShow: 1.35
//       }
//     }
//   ]
// });


});

function initProductSlider() {
    var $slider = $('.product-slider');

    if (!$slider.length) return;

    if ($slider.hasClass('slick-initialized')) return;

    $slider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 1441,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1.35
                }
            }
        ]
    });
}

// Keep trying every 300ms until slider is initialized
setInterval(function () {
    initProductSlider();
}, 300);



document.querySelectorAll('.quantity-selector').forEach((selector) => {
  const plusBtn = selector.querySelector('.qty-btn.plus');
  const minusBtn = selector.querySelector('.qty-btn.minus');
  const input = selector.querySelector('.quantity-input');

  plusBtn.addEventListener('click', () => {
    input.value = parseInt(input.value, 10) + 1;
  });

  minusBtn.addEventListener('click', () => {
    if (parseInt(input.value, 10) > 1) {
      input.value = parseInt(input.value, 10) - 1;
    }
  });
});


// Menu
document.addEventListener("click", function (e) {
  const trigger = e.target.closest(".click-menu");

  if (trigger) {
    e.stopPropagation();

    // Remove active from all mega menus
    document.querySelectorAll(".mega-menu-content").forEach(menu => {
      menu.classList.remove("active");
    });

    // Remove active from all li
    document.querySelectorAll(".click-menu").forEach(btn => {
      btn.closest("li")?.classList.remove("active");
    });

    // Add body class
    document.body.classList.add("menu-open");

    // Add active to current mega menu
    const megaMenu = trigger.nextElementSibling;
    if (megaMenu && megaMenu.classList.contains("mega-menu-content")) {
      megaMenu.classList.add("active");
    }

    // Add active to current li
    trigger.closest("li")?.classList.add("active");

    return;
  }

  // Outside click
  if (!e.target.closest(".mega-menu-content")) {
    document.body.classList.remove("menu-open");

    document.querySelectorAll(".mega-menu-content").forEach(menu => {
      menu.classList.remove("active");
    });

    document.querySelectorAll(".click-menu").forEach(btn => {
      btn.closest("li")?.classList.remove("active");
    });
  }
});